import MyAutocomplete from './MyAutocomplete';

export default MyAutocomplete;

export { default as MinibarAutoCompleteV2 } from './MinibarAutoComplete/V2';
export { default as ClientAutoCompleteV2 } from './ClientAutoComplete/V2';